import { useState, useEffect } from "react";

/**
 * useDebounce
 * Delays updating the value until user stops typing
 *
 * Why:
 * - prevents filtering on every keystroke
 * - reduces CPU work for large fleet lists (1000+ vehicles)
 */
export default function useDebounce(value, delay = 300) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // cleanup runs if value changes before delay finishes
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}